class ProductForm extends HTMLElement {
  constructor() {
    super();
    this.formTarget = this.closest(".main-product").querySelector(
      "[data-product-form-target]",
    );
    this.disableScrollUp = true;
  }

  connectedCallback() {
    this.addEventListener("variant:changed", (e) => {
      const { variant } = e.detail;

      this._updateAtcs(variant);
      this._updateIdInputs(variant);
      this._updateBisButtons(variant);

      if (!variant) return;

      this._updatePrices(variant);
      this._updateUrl(variant);
    });

    this.addEventListener("pdp-variant-button:updated", () => {
      if (!this.disableScrollUp) {
        window.scrollTo({
          top: 0,
          behavior: "smooth",
        });
      }
    });

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        !entry.isIntersecting
          ? (this.disableScrollUp = false)
          : (this.disableScrollUp = true);
      });
    });

    observer.observe(this.formTarget);
  }

  disconnectedCallback() {}

  get atcs() {
    return this.querySelectorAll("[data-product-form-atc]");
  }

  get bisButtons() {
    return this.querySelectorAll("back-in-stock-button");
  }

  get prices() {
    return this.closest(".main-product").querySelectorAll("price-snippet");
  }

  get idInputs() {
    return this.querySelectorAll('input[name="id"]');
  }

  get updateUrl() {
    return !this.hasAttribute("disable-update-url");
  }

  get form() {
    return this.querySelector("form");
  }

  _updateAtcs(variant) {
    this.atcs.forEach((atc) => {
      atc.disabled = !variant || !variant.available;

      const atcButton = atc.querySelector("add-to-cart");
      let atcAvailableText = window.productStrings.addToCart;
      if (atcButton.hasAttribute("data-is-preorder")) {
        atcAvailableText = window.productStrings.preOrder;
      }

      atcButton.textContent =
        variant && variant.available
          ? atcAvailableText
          : window.productStrings.outOfStock;
    });
  }

  _updateBisButtons(variant) {
    this.bisButtons.forEach((button) => {
      button.setAttribute("selected-variant", variant.id);

      if (variant && variant.available) {
        button.style.display = "none";
      } else {
        button.style.display = "flex";
      }
    });
  }

  _updatePrices(variant) {
    this.prices.forEach((price) => {
      price.setAttribute("price", variant.price / 100);
      price.setAttribute("compare-at-price", variant.compare_at_price / 100);
      price.setAttribute("currency", window.Shopify.currency.active);
      price.setAttribute("dynamic", "");
    });
  }

  _updateIdInputs(variant) {
    this.idInputs.forEach((idInput) => {
      idInput.value = variant?.id || "";
    });
  }

  _updateUrl(variant) {
    const url = new URL(window.location);

    if (!window.Shopify.designMode && this.updateUrl) {
      url.searchParams.set("variant", variant.id);
      window.history.replaceState("", "", url);
    }
  }
}

if (!customElements.get("product-form")) {
  customElements.define("product-form", ProductForm);
}
